import CONFIG from "@APP/config";
import { BankObject, MetroBankAccountDetails } from "@APP/types";

import request from "../request";

export const getMetroBankAccountsDetails = async (email: string) => {
  const response = await request<MetroBankAccountDetails>({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/banks/metro/accounts/${email}`,
  });

  return response.data;
};

export const disableOrEnableBankAccount = async (
  typeOfAction: "disable" | "enable",
  orgId: string,
) => {
  return request({
    method: "PUT",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/banks/metro/accounts/${typeOfAction}`,
    data: { orgId },
  });
};

export const deleteBankAccount = async (orgId: string) => {
  return request({
    method: "DELETE",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/banks/metro/accounts`,
    data: { orgId },
  });
};

export const getBankDetails = async (orgId: string) => {
  const response = await request<BankObject>({
    method: "GET",
    url: `${CONFIG.API.ROOT_URL}/${CONFIG.API.VERSION}/admin/banks/organisations/${orgId}`,
  });

  return response.data;
};
